import { createApp } from 'vue'
import App from './App.vue'
import router from '../router/index'
import Vant from 'vant';
import 'vant/lib/index.css';
import dayjs from "dayjs"
import * as echarts from 'echarts'
import {post,get,patch,put} from '../utils/http'
import { showConfirmDialog, showToast, showDialog, showNotify } from 'vant';
import { DatePicker } from 'vant';

const app = createApp(App);
app.use(DatePicker);
app.use(router).use(Vant).mount('#app')
app.config.globalProperties.$dayjs = dayjs

app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$post=post;
app.config.globalProperties.$get=get;
app.config.globalProperties.$patch=patch;
app.config.globalProperties.$put=put;
app.config.globalProperties.$toast=showToast;
app.config.globalProperties.$showConfirmDialog=showConfirmDialog;
app.config.globalProperties.$dialog=showDialog ;
app.config.globalProperties.$Notify=showNotify ;
app.config.globalProperties.$notify=showNotify ;
